
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/bizee",
      function () {
        return require("private-next-pages/partners/bizee.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/bizee"])
      });
    }
  